import * as actions from "./actionTypes";
import * as Helpers from "../global/Helpers";


let isTickerVisibleInitial = Helpers.getIsTickerVisible();
const initialState = {

    connectionStatus: null,
    symbolSelected: null,
    orderTypeSelected: null,
    symbols: [],
    accounts: [],
    allAccounts: [],
    activeProfile: {
        ProfileID: null,
        ProfileName: null,
        ProfileNameAr: null,
        ProfileSettings: null,
        WebCode: null,

        isLocked: false,
        isSearch: false,
        profileUniqueID: null,
    },
    orders: [],
    orderSelected: null,
    IsorderSelectedAgain: false,
    notificationCount: null,
    exchanges: [],
    isDarkMode: false,
    signalr_connection: null,
    symbolDetails: null,
    profileIdSelected: null,
    profiles: [],
    subscribedSymbols: [],
    subscribedSymbolsTicker: [],
    isSubscribedSymbolsChanged: false,
    isLoaderVisible: false,
    isNewWorkspaceLayout: false,
    isAlertDeleted: false,
    AlertDeleted: 0,
    SymbolDeleted: "",
    isConditionalOrderDeleted: false,
    config: null,
    isSidebarOpen: false,
    isTickerVisible: isTickerVisibleInitial, //binded intial value of redux to local storage
    symbolSelectedForLinkingTab: "",
    linkingColorAnyScreen: null,
    linkingTab: [],
    permData: null,
    isSidebarMenuOpen: true,
    isNewWorkspaceChartLayout: false,
    workspaceChartProfiles: [],
    workspaceChartAdvanceFocous: "",
    AdvanceSerachSymbol: "",
    SelectdProfiles: [],
    IsProfilesUpdated: false,
    ProfileList: [],
    Indexes: [],
    EnableExpandRow: false,
    refreashTimeSettings: [20, 20, 1, 1],
    numberofTradingSettings: [20, 20],
    BidPrice: "",
    BidVolume: "",
    OfferPrice: "",
    OfferVolume: "",
    BidPriceOrderPopUP: null,
    BidVolumeOrderPopUP: null,
    OfferPriceOrderPopUP: null,
    OfferVolumeOrderPopUP: null,
    SymbolTrades: [],
    MarketWatchDatafeed: "",
    mboDataFeed: "",
    mbpDataFeed: "",
    SymbolNewData: "",
    SymbolToBesubscribed: [],
    OrderIsUpdated: 0,
    ClientIDOrderIsUpdated: "",
    OrderDataFeed: null,
    defaultWorkspace: {
        ProfileID: null,
        ProfileName: null,
        ProfileNameAr: null,
        ProfileSettings: null,
        WebCode: null,
        isLocked: false,
        isSearch: false,
        profileUniqueID: null,
    },
    ActiveProfileForDefaultWorkspace: {
        ProfileID: null,
        ProfileName: null,
        ProfileNameAr: null,
        ProfileSettings: null,
        profileUniqueID: "",
        WebCode: null,
        isLocked: false,
        isSearch: false,
        profileUniqueID: null,
    },
    workSpaceLayoutsNumber: null,
    SymbolTSSubscrib: [],
    marketOverviewProfile: null,
    MarketTrades: [],
    selectedAccountFromPortfolioWorkspace: [],
    selectedSymbolFromPortfolio: null,
    Comp_IDFromPortfolio: null,
    PreferredSymbol: "",
    portfolioData: [],
    totalHoldingCost: 0,
    QtyFromPortfolio: {
        Symbol: "",
        Qty: 0,
    },
    //RowFromMW: null,
    isRowInMWClicked: 0,
    portfolioDataFirstReq: [],
    PreferredExchange: null,
    Settings: null,
    ActiveWorkspaceUniqueID: "T",
    AvgIndexes: [],
    EnableTradeTicker: false,
    EnableRoundTicker: false,
    PopulatedRiskManagement: false,
    IsMobileSize: false,
    lookups: [],
    SectorOfMarket: [],
    IDValidityResult: null,
    OrigenalExchanges: [],
    PreferredLangAcc: null,
    MainClientID_DefaultAcc: null,
    fromBasketOrder: false,
    updateFromBasketOrder: false,
    basketOrderObject: [],
    GroupName: [],
    //mustafa
    ObjectTradeMarket: { Symbol: "", BuyOrSell: "" },
    fromTradeMarket: false,
    SelectedAccountSummaries: null
};

const reducer = (state = initialState, action) => {
    const newState = { ...state };

    switch (action.type) {
        case actions.SYMBOL_CHANGED:
            newState.symbolSelected = action.payload.symbolSelected;
            newState.orderTypeSelected = action.payload.orderTypeSelected;
            newState.BidPriceOrderPopUP = action.payload.BidPriceOrderPopUP;
            newState.BidVolumeOrderPopUP = action.payload.BidVolumeOrderPopUP;
            newState.OfferPriceOrderPopUP = action.payload.OfferPriceOrderPopUP;
            newState.OfferVolumeOrderPopUP = action.payload.OfferVolumeOrderPopUP;
            newState.PopulatedRiskManagement = action.payload.PopulatedRiskManagement;
            break;
        case actions.GET_SYMBOLS:
            let newState1 = Object.assign({}, state);
            newState1.symbols = action.payload.symbols;
            return newState1;
            break;
        case actions.GET_ACCOUNTS:

            state = {
                ...state,
                accounts: action.payload.accounts,
                allAccounts: action.payload.allAccounts,
            };
            return state;
        case actions.SET_ACTIVE_PROFILE:
            newState.activeProfile = action.payload.activeProfile;
            break;
        case actions.GET_ORDERS:
            state = {
                ...state,
                orders: action.payload.orders,
            };
            return state;
        case actions.APPEND_ORDERS:
            let oldorders = state.orders;
            let NewOrder = [action.payload.appendOrder];

            let checkofOrderExist = oldorders.filter(
                (ord) => ord.OrderID === NewOrder[0].OrderID
            );
            if (checkofOrderExist.length > 0 && checkofOrderExist !== null) {
                let NewOrders = oldorders.map(
                    (ex) => NewOrder.find((e) => e.OrderID === ex.OrderID) || ex
                );
                state = {
                    ...state,
                    orders: NewOrders,
                };
                return state;
            }
            state = {
                ...state,
                orders: [...state.orders, action.payload.appendOrder],
            };
            return state;
        case actions.GET_SIGNALR:
            state = {
                ...state,
                signalr_connection: action.payload.signalr_connection,
            };
            return state;
        case actions.SELECT_ORDER:
            state = {
                ...state,
                orderSelected: action.payload.orderSelected,
                IsorderSelectedAgain: true,
            };
            return state;
        case actions.SET_ORDER_SELECTED_FALSE:
            state = {
                ...state,
                IsorderSelectedAgain: false,
            };
            return state;
        case actions.SET_NOTIFICATION_COUNT:
            newState.notificationCount = action.payload.notificationCount;
            break;
        case actions.DECREMENT_NOTIFICATION_COUNT:
            newState.notificationCount = newState.notificationCount - 1;
            break;
        case actions.INCREMENT_NOTIFICATION_COUNT:
            newState.notificationCount = newState.notificationCount + 1;
            break;
        case actions.GET_EXCHANGES:
            state = {
                ...state,
                exchanges: action.payload.exchanges,
            };
            return state;
        case actions.GET_INDEXES:
            state = {
                ...state,
                Indexes: action.payload.Indexes,
            };
            return state;
        case actions.GET_EXCHANGES_UPDATE:
            let oldexchange = state.exchanges;

            if (
                oldexchange !== null &&
                oldexchange !== [] &&
                (action.payload.exchangesUpdate !== null) &
                (action.payload.exchangesUpdate !== []) &
                (action.payload.exchangesUpdate !== undefined) &&
                action.payload.exchangesUpdate.length > 0
            ) {
                let Newexchange = oldexchange.map(
                    (ex) =>
                        action.payload.exchangesUpdate.find(
                            (e) => e.ExchangeID === ex.ExchangeID
                        ) || ex
                );
                if (Newexchange !== null && Newexchange.length > 0) {
                    if (!Newexchange[0].hasOwnProperty("ExchangeNameE")) {
                        var result = Newexchange.map((el) => {
                            var o = Object.assign({}, el);
                            o.ExchangeNameE = el.NameE;
                            o.ExchangeNameA = el.NameA;
                            return o;
                        });
                        Newexchange = result;
                    }
                    if (!Newexchange[0].hasOwnProperty("EquityTransferComm")) {
                        var result = Newexchange.map((el) => {
                            var o = Object.assign({}, el);
                            o.EquityTransferComm =
                                oldexchange.filter((old) => old.ExchangeID == el.ExchangeID)[0][
                                "EquityTransferComm"
                                ] ?? 0;
                            return o;
                        });
                        Newexchange = result;
                    }

                    if (!Newexchange[0].hasOwnProperty("IndexAvailable")) {
                        var result = Newexchange.map((el) => {
                            var o = Object.assign({}, el);
                            o.IndexAvailable =
                                oldexchange.filter((old) => old.ExchangeID == el.ExchangeID)[0][
                                "IndexAvailable"
                                ] ?? 0;
                            return o;
                        });
                        Newexchange = result;
                    }


                    // if (!Newexchange[0].hasOwnProperty("ORDER_INDEX")) {
                    //     var result = Newexchange.map((el) => {
                    //         var o = Object.assign({}, el);
                    //         o.ORDER_INDEX = oldexchange.filter((old) => (old.ExchangeID == el.ExchangeID))[0]["ORDER_INDEX"] ?? 0;
                    //         return o;
                    //     })
                    //     Newexchange = result;
                    // }
                    // if (!Newexchange[0].hasOwnProperty("EquityTransferComm") || !Newexchange[0].hasOwnProperty("ConfirmMessage") || !Newexchange[0].hasOwnProperty("ConfirmMessageAR") ) {
                    //     var result = Newexchange.map((el) => {
                    //         var o = Object.assign({}, el);
                    //         o.EquityTransferComm = oldexchange.filter((old) => (old.ExchangeID == el.ExchangeID))[0]["EquityTransferComm"] ?? 0;
                    //         o.ConfirmMessage = oldexchange.filter((old) => (old.ExchangeID == el.ExchangeID))[0]["ConfirmMessage"] ?? "";
                    //         o.ConfirmMessageAR = oldexchange.filter((old) => (old.ExchangeID == el.ExchangeID))[0]["ConfirmMessageAR"] ?? "";
                    //         return o;
                    //     })
                    //     Newexchange = result;
                    // }
                }
                //console.log("NewexchangeRedux", Newexchange)
                state = {
                    ...state,
                    exchanges: Newexchange,
                };
            }
            return state;
        case actions.SET_DARK_MODE:
            newState.isDarkMode = action.payload.isDarkMode;
            break;
        case actions.SET_SYMBOL_DETAILS:
            state = {
                ...state,
                symbolDetails: action.payload.symbolDetails,
            };
            return state;
        case actions.SET_PROFILE_ID_SELECTED:
            state = {
                ...state,
                profileIdSelected: action.payload.profileIdSelected,
            };
            return state;
        case actions.SET_PROFILES:
            state = {
                ...state,
                profiles: action.payload.profiles,
            };
            return state;
        case actions.SET_PERM_DATA:
            state = {
                ...state,
                permData: action.payload.permData,
            };
            return state;
        case actions.SET_SUBSCRIBED_SYMBOLS:
            state = {
                ...state,
                subscribedSymbols: action.payload.subscribedSymbols,
            };
            return state;
        case actions.SET_IS_SUBSCRIBED_SYMBOLS_CHANGED:
            state = {
                ...state,
                isSubscribedSymbolsChanged: action.payload.isSubscribedSymbolsChanged,
            };
            return state;
        case actions.SET_IS_LOADER_VISIBLE:
            state = {
                ...state,
                isLoaderVisible: action.payload.isLoaderVisible,
            };
            return state;
        case actions.SET_IS_NEW_WORKSPACE_LAYOUT:
            state = {
                ...state,
                isNewWorkspaceLayout: action.payload.isNewWorkspaceLayout,
            };
            return state;
        case actions.SET_IS_ALERT_DELETED:
            state = {
                ...state,
                isAlertDeleted: action.payload.isAlertDeleted,
                AlertDeleted: action.payload.AlertDeleted,
                SymbolDeleted: action.payload.SymbolDeleted,
            };
            return state;
        case actions.SET_IS_CONDITIONAL_ORDER_DELETED:
            state = {
                ...state,
                isConditionalOrderDeleted: action.payload.isConditionalOrderDeleted,
            };
            return state;
        case actions.SET_CONFIG:
            state = {
                ...state,
                config: action.payload.config,
            };
            return state;
        case actions.SET_IS_SIDEBAR_OPEN:
            state = {
                ...state,
                isSidebarOpen: action.payload.isSidebarOpen,
            };
            return state;
        case actions.SET_IS_TICKER_VISIBLE:
            state = {
                ...state,
                isTickerVisible: action.payload.isTickerVisible,
            };
            return state;
        case actions.LINKING_TAP:
            newState.symbolSelectedForLinkingTab =
                action.payload.symbolSelectedForLinkingTab;
            newState.ColorFromAgGrideContainer =
                action.payload.ColorFromAgGrideContainer;
            newState.BidPrice = action.payload.BidPrice;
            newState.BidVolume = action.payload.BidVolume;
            newState.OfferPrice = action.payload.OfferPrice;
            newState.OfferVolume = action.payload.OfferVolume;
            state.ColorFromAgGrideContainer =
                action.payload.ColorFromAgGrideContainer;
            state.symbolSelectedForLinkingTab =
                action.payload.symbolSelectedForLinkingTab;
            state.BidPrice = action.payload.BidPrice;
            state.BidVolume = action.payload.BidVolume;
            state.OfferPrice = action.payload.OfferPrice;
            state.OfferVolume = action.payload.OfferVolume;
            break;

        case actions.LINKING_ALL_TAPS_OPEN:
            if (
                action.payload.allTabWithColor !== undefined &&
                action.payload.allTabWithColor !== null &&
                action.payload.allTabWithColor !== ""
            ) {
                state = {
                    ...state,
                    linkingTab: action.payload.allTabWithColor,
                };
            }
            return state;
        case actions.SET_ADVANCE_SEARCH_SYMBOL:
            if (
                action.payload.Symbol !== undefined &&
                action.payload.Symbol !== null &&
                action.payload.Symbol !== ""
            ) {
                state = {
                    ...state,
                    AdvanceSerachSymbol: action.payload.Symbol,
                };
            }
            return state;

        case actions.CLOSE_BTN:
            state = {
                ...state,
                isOpen: action.isOpen,
            };
            return state;
        case actions.SET_IS_SIDEBAR_MENU_OPEN:
            state = {
                ...state,
                isSidebarMenuOpen: action.payload.isSidebarMenuOpen,
            };
            return state;
        case actions.SET_IS_NEW_WORKSPACE_CHART_LAYOUT:
            state = {
                ...state,
                isNewWorkspaceChartLayout: action.payload.isNewWorkspaceChartLayout,
            };
            return state;

        case actions.WORKSPACE_CHART_PROFILES:
            state = {
                ...state,
                workspaceChartProfiles: action.payload.workspaceChartProfiles,
            };
            return state;
        case actions.SET_IS_NEW_WORKSPACE_CHART_ADVANCE_FOCOUS:
            state = {
                ...state,
                workspaceChartAdvanceFocous: action.payload.workspaceChartAdvanceFocous,
            };
            return state;
        case actions.IS_PROFILES_UPDATED:
            state = {
                ...state,
                IsProfilesUpdated: action.payload.IsProfilesUpdated,
            };
            return state;
        case actions.IS_ADD_DELETE_PROFILE:
            state = {
                ...state,
                IsAddOrDeleteProfile: action.payload.IsAddOrDeleteProfile,
            };
            return state;
        case actions.UPDATE_ENABLE_EXPAND_ROW:
            state = {
                ...state,
                EnableExpandRow: action.payload.EnableExpandRow,
            };
            return state;
        case actions.UPDATE_RFREASH_TIME_SETTINGS:
            state = {
                ...state,
                refreashTimeSettings: action.payload.refreashTimeSettings,
            };
            return state;
        case actions.UPDATE_NUM_OF_TRADING:
            state = {
                ...state,
                numberofTradingSettings: action.payload.numberofTradingSettings,
            };
            return state;
        case actions.MARKET_WATCH_UPDATE:
            state = {
                ...state,
                MarketWatchDatafeed: action.payload.MarketWatchDatafeed,
            };
            return state;
        case actions.MARKET_DEPTH_UPDATE:
            state = {
                ...state,
                SymbolNewData: action.payload.SymbolNewData,
                mboDataFeed: action.payload.mboDataFeed,
                mbpDataFeed: action.payload.mbpDataFeed,
            };
            return state;
        case actions.SET_SUBSCRIBED_SYMBOLS_TICKER:
            state = {
                ...state,
                subscribedSymbolsTicker: action.payload.subscribedSymbolsTicker,
            };
            return state;
        case actions.ORDER_IS_UPDATED:
            //
            state = {
                ...state,
                OrderIsUpdated: action.payload.OrderIsUpdated,
                ClientIDOrderIsUpdated: action.payload.ClientIDOrderIsUpdated,
            };
            return state;
        case actions.ORDER_LIST_DATAFEED:
            state = {
                ...state,
                OrderDataFeed: action.payload.OrderDataFeed,
            };
            return state;
        case actions.SET_SYMBOLS_TO_SUBSCRIBED:
            let SymbolToBesubscribed = state.SymbolToBesubscribed;
            if (
                SymbolToBesubscribed !== null &&
                SymbolToBesubscribed.length > 0 &&
                SymbolToBesubscribed !== []
            ) {
                let filterSymbolToBesubscribed = SymbolToBesubscribed.filter(
                    (sss) => sss.ScreenID === action.payload.ScreenID
                );
                if (filterSymbolToBesubscribed.length > 0) {
                    let symbols = {
                        ScreenID: action.payload.ScreenID,
                        Symbol: action.payload.Symbol,
                    };
                    var foundIndex = SymbolToBesubscribed.findIndex(
                        (x) => x.ScreenID == symbols.ScreenID
                    );
                    SymbolToBesubscribed[foundIndex] = symbols;
                } else {
                    SymbolToBesubscribed.push({
                        ScreenID: action.payload.ScreenID,
                        Symbol: action.payload.Symbol,
                    });
                }
            } else {
                SymbolToBesubscribed.push({
                    ScreenID: action.payload.ScreenID,
                    Symbol: action.payload.Symbol,
                });
            }
            state = {
                ...state,
                SymbolToBesubscribed: SymbolToBesubscribed,
            };
            return state;
        case actions.SYMBOL_TIME_SALE_SUB:
            let SymbolTSSubscrib = state.SymbolTSSubscrib;
            if (
                SymbolTSSubscrib !== null &&
                SymbolTSSubscrib.length > 0 &&
                SymbolTSSubscrib !== []
            ) {
                let filterSymbolTSSubscrib = SymbolTSSubscrib.filter(
                    (sss) => sss.ScreenID === action.payload.ScreenID
                );
                if (filterSymbolTSSubscrib.length > 0) {
                    let symbols = {
                        ScreenID: action.payload.ScreenID,
                        Symbol: action.payload.Symbol,
                    };
                    var foundIndex = SymbolTSSubscrib.findIndex(
                        (x) => x.ScreenID == symbols.ScreenID
                    );
                    SymbolTSSubscrib[foundIndex] = symbols;
                } else {
                    SymbolTSSubscrib.push({
                        ScreenID: action.payload.ScreenID,
                        Symbol: action.payload.Symbol,
                    });
                }
            } else {
                SymbolTSSubscrib.push({
                    ScreenID: action.payload.ScreenID,
                    Symbol: action.payload.Symbol,
                });
            }
            state = {
                ...state,
                SymbolTSSubscrib: SymbolTSSubscrib,
            };
            return state;
        case actions.UPDATE_SYMBOL_TIME_SALE_SUB:
            let UpdateSymbolTSSubscrib = action.payload.SymbolTSSubscrib;

            state = {
                ...state,
                SymbolTSSubscrib: UpdateSymbolTSSubscrib,
            };
            return state;
        case actions.SYMBOL_TRADES_DATAFEED:
            let OldDataFeed = state.SymbolTrades.filter(
                (trades) => trades.Symbol !== action.payload.Symbol
            );
            let Trades = OldDataFeed;
            Trades = [...action.payload.SymbolTrades];
            state = {
                ...state,
                SymbolTrades: Trades,
            };
            return state;
        case actions.UPDATE_SELECTED_PROFILE:
            let SelectdProfiles = state.SelectdProfiles;
            let IsProfilesUpdated = false;
            if (
                SelectdProfiles !== null &&
                SelectdProfiles.length > 0 &&
                SelectdProfiles !== []
            ) {
                let filterprofiles = SelectdProfiles.filter(
                    (SelectdProfiles) =>
                        SelectdProfiles.ScreenProfileID === action.payload.ScreenID
                );
                if (filterprofiles.length > 0) {
                    let profile = {
                        ProfileID: action.payload.ProfileID,
                        ScreenProfileID: action.payload.ScreenID,
                    };
                    var foundIndex = SelectdProfiles.findIndex(
                        (x) => x.ScreenProfileID == profile.ScreenProfileID
                    );
                    SelectdProfiles[foundIndex] = profile;
                } else {
                    let profile = {
                        ProfileID: action.payload.ProfileID,
                        ScreenProfileID: action.payload.ScreenID,
                    };
                    SelectdProfiles.push(profile);
                }
                IsProfilesUpdated = true;
            } else {
                let profile = {
                    ProfileID: action.payload.ProfileID,
                    ScreenProfileID: action.payload.ScreenID,
                };
                SelectdProfiles.push(profile);
                IsProfilesUpdated = true;
            }
            state = {
                ...state,
                SelectdProfiles: SelectdProfiles,
                IsProfilesUpdated: IsProfilesUpdated,
            };
            return state;
        case actions.SET_DEFAULT_WORKSPACE:
            state = {
                ...state,
                defaultWorkspace: action.payload.defaultWorkspace,
            };
            return state;
        case actions.SET_WORKSPACE_LAYOUTS_NUMBER:
            newState.workSpaceLayoutsNumber = action.payload.workSpaceLayoutsNumber;
            break;

        case actions.SET_ACTIVE_PROFILE_FOR_DEFAULT_WORKSPACE:
            state = {
                ...state,
                ActiveProfileForDefaultWorkspace:
                    action.payload.ActiveProfileForDefaultWorkspace,
            };
            return state;
        case actions.SET_MAEKET_FOR_MARKET_OVER_VIEW_PROFILE:
            newState.marketOverviewProfile = action.payload.marketOverviewProfile;
            break;
        case actions.MARKET_TRADES:
            let OldDataFeedMarket = state.MarketTrades.filter(
                (trades) => trades.Exchange !== action.payload.Market
            );
            let MarketTrades = OldDataFeedMarket;
            MarketTrades = [...action.payload.MarketTrades];
            state = {
                ...state,
                MarketTrades: MarketTrades,
            };
            return state;
        case actions.SELECTED_ACCOUNT_FROM_PORTFOLIO_WORKSPACE:
            newState.selectedAccountFromPortfolioWorkspace =
                action.payload.selectedAccountFromPortfolioWorkspace;
            break;
        case actions.SET_SELECT_SYMBOL_FROM_PORTFOLIO:
            newState.selectedSymbolFromPortfolio =
                action.payload.selectedSymbolFromPortfolio;
            newState.Comp_IDFromPortfolio = action.payload.Comp_IDFromPortfolio;
            break;
        case actions.SELECT_PREFERRED_SYMBOL:
            state = {
                ...state,
                PreferredSymbol: action.payload.PreferredSymbol,
            };
            return state;

        case actions.SYBMOL_QTY_TO_SELL:
            state = {
                ...state,
                QtyFromPortfolio: {
                    ...state.QtyFromPortfolio,
                    Symbol: action.payload.Symbol,
                    Qty: action.payload.Qty,
                    ClientID: action.payload.ClientID,
                    Exchange: action.payload.Exchange,
                },
            };
            return state;
        case actions.SET_PORTFOLIO_Data:
            state = {
                ...state,
                portfolioData: action.payload.portfolioData,
                totalHoldingCost: action.payload.totalHoldingCost,
            };
            return state;
        // case actions.selected_Row_From_MW:
        //     //
        //     state = {
        //         ...state,
        //         RowFromMW: action.payload.RowFromMW,
        //     };
        //     return state;
        case actions.IS_Row_In_MW_Clicked:
            state = {
                ...state,
                isRowInMWClicked: action.payload.isRowInMWClicked,
            };
            return state;
        case actions.PORTFOLIO_FIRST_REQUEST:
            state = {
                ...state,
                portfolioDataFirstReq: action.payload.portfolioDataFirstReq,
            };
            return state;
        case actions.CHECK_CONNECTION:
            state = {
                ...state,
                connectionStatus: action.payload.connectionStatus,
            };
            return state;

        case actions.SELECT_PREFERRED_EXCHANGE:
            state = {
                ...state,
                PreferredExchange: action.payload.PreferredExchange,
            };
            return state;
        case actions.USER_SETTINGS:
            state = {
                ...state,
                Settings: action.payload.Settings,
            };
            return state;
        case actions.USER_SETTINGS:
            state = {
                ...state,
                Settings: action.payload.Settings,
            };
            return state;
        case actions.AVG_INDEXES:
            state = {
                ...state,
                AvgIndexes: action.payload.AvgIndexes,
            };
            return state;
        case actions.ENABLE_TRADE_TICKER:
            state = {
                ...state,
                EnableTradeTicker: action.payload.EnableTradeTicker,
            };
            return state;
        case actions.ENABLE_ROUND_TICKER:
            state = {
                ...state,
                EnableRoundTicker: action.payload.EnableRoundTicker,
            };
            return state;
        case actions.Is_Mobile_Size:
            state = {
                ...state,
                IsMobileSize: action.payload.IsMobileSize,
            };
        case actions.GET_LOOKUPS:

            state = {
                ...state,
                lookups: action.payload.lookups,
            };
            return state;
        case actions.GET_SectorOfMarket:
            state = {
                ...state,
                SectorOfMarket: action.payload.SectorOfMarket,
            };
            return state;
        case actions.Active_Workspace_UniqueID:

            state = {
                ...state,
                ActiveWorkspaceUniqueID: action.payload.ActiveWorkspaceUniqueID,
            };
            return state;
        case actions.get_ID_Validity_Result:
            state = {
                ...state,
                IDValidityResult: action.payload.IDValidityResult,
            };
            return state;
        case actions.GET_ExchangesOriginal:
            state = {
                ...state,
                OrigenalExchanges: action.payload.OrigenalExchanges,
            };
            return state;
        case actions.get_BasketOrder:
            state = {
                ...state,
                fromBasketOrder: action.payload.fromBasketOrder,
            };
            return state;
        case actions.get_updateFromBasketOrder:
            state = {
                ...state,
                updateFromBasketOrder: action.payload.updateFromBasketOrder,
            };
            return state;
        case actions.get_basketOrderObject:
            state = {
                ...state,
                basketOrderObject: action.payload.basketOrderObject,
            };
            return state;
        case actions.get_GroupName:
            state = {
                ...state,
                GroupName: action.payload.GroupName,
            };
            return state;
        case actions.Get_Default_AccountInfo:
            state = {
                ...state,
                PreferredLangAcc: action.payload.PreferredLangAcc,
                MainClientID_DefaultAcc: action.payload.MainClientID_DefaultAcc,
            };
            return state;
        case actions.GET_EXCHANGES_UPDATE_EnableTags:

            return Helpers.ExchangesUpdateEnableTagValue(state, action.payload.exchangesUpdate, true)
        // let oldexchangeArr = state.OrigenalExchanges

        // if (
        //     oldexchangeArr !== null &&
        //     oldexchangeArr !== [] &&
        //     (action.payload.exchangesUpdate !== null) &
        //     (action.payload.exchangesUpdate !== []) &
        //     (action.payload.exchangesUpdate !== undefined) &&
        //     action.payload.exchangesUpdate.length === undefined
        // ) {
        //     
        //     var list2 = []
        //     let oldExchange = oldexchangeArr.find((e) => e.ExchangeID === action.payload.exchangesUpdate.ExchangeID);

        //     if (oldExchange !== undefined && oldExchange !== null) {
        //         var keysOfNewData = Object.keys(action.payload.exchangesUpdate);
        //         keysOfNewData.forEach(key => {
        //             if (key !== "ExchangeID")
        //                 oldExchange[key] = action.payload.exchangesUpdate[key];
        //         });
        //         list2.push(oldExchange);
        //         oldexchangeArr.map(obj => list2.find(o => o.ExchangeID === obj.ExchangeID) || obj);
        //         console.log("rajaa", oldexchangeArr)
        //         state = {
        //             ...state,
        //             exchanges: oldexchangeArr,
        //         };
        //         return state;
        //     }

        // }
        // else if (
        //     oldexchangeArr !== null &&
        //     oldexchangeArr !== [] &&
        //     (action.payload.exchangesUpdate !== null) &
        //     (action.payload.exchangesUpdate !== []) &
        //     (action.payload.exchangesUpdate !== undefined) &&
        //     action.payload.exchangesUpdate.length > 0
        // ) {
        //     let Newexchange = oldexchangeArr.map(
        //         (ex) =>
        //             action.payload.exchangesUpdate.find(
        //                 (e) => e.ExchangeID === ex.ExchangeID
        //             ) || ex
        //     );
        // }
        // return state;
        //mustafa
        case actions.Get_TradeMarket_Object:
            state = {
                ...state,
                ObjectTradeMarket: action.payload.ObjectTradeMarket,
            };
            return state;
        //mustafa
        case actions.From_TradeMarket:
            state = {
                ...state,
                fromTradeMarket: action.payload.fromTradeMarket,
            };
            return state;
        case actions.Selected_Account_Summaries:
            newState.SelectedAccountSummaries = action.payload.SelectedAccountSummaries;
            break;
        default:
            break;
    }
    return newState;
};

export default reducer;
